import { Component, DoCheck, OnInit } from '@angular/core';
import { HelpersService } from '../../services/helpers.service';
import { StreamService } from '../../services/stream-servises/stream.service';
import { Subscription } from 'rxjs';
import { LegacyMigrationService } from '../../services/legacy-migration.service';

@Component({ standalone: false,
  selector: 'vfa-cp-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit, DoCheck {
  private sub$: Subscription = new Subscription;
  public initWizard: boolean = false;
  public visibleWizard: boolean = false;
  public data: any;
  public steps: any;
  public currentStep: number = 0;
  public currentPath: string = '';

  constructor(public helpersService: HelpersService, private legacyMigrationService: LegacyMigrationService, private streamService: StreamService) {}

  ngOnInit(): void {
    this.sub$ = this.streamService.data.obs.subscribe(res => {
      this.onGetData(res);
    });
  }

  ngDoCheck() {
    if(this.currentPath !== window.location.pathname) {
      this.currentPath = window.location.pathname;
      if(this.currentPath.includes("/auth/first-login") || this.currentPath.includes("/auth/welcome")) {
        this.visibleWizard = false;
      } else {
        this.visibleWizard = true;
        this.getSteps();
      }
    }
  }

  onGetData(data: any) {
    if (!data) {
      return this.streamService.getData();
    }
    this.data = data;
    this.currentPath = window.location.pathname;
    this.getSteps();
  }

  public getSteps() :void {
    let defaultRoute = false;
    if(this.helpersService.isRenewal) {
      this.steps = this.helpersService.renewalProcessFlow.routes;
    } else if(this.helpersService.isLegacy || this.data?.isMigratedUser){
      if(this.data) {
        this.data.model = "B2B";
      }
      this.steps = this.legacyMigrationService.legacyMigrationProcessFlow.routes;
      this.steps = this.helpersService.initialProcessFlow.routes.concat(this.steps);
    } else {
      if(this.data?.model === 'B2C'){
        this.steps = this.helpersService.recoveryProcessFlow[2].routes;
      } else if(this.data?.model === 'B2B'){
        this.steps = this.helpersService.recoveryProcessFlow[1].routes;
      } else{
        defaultRoute = true;
        this.steps = this.helpersService.ordersProcessFlow.routes;
      }
      if(!defaultRoute) {
        this.steps = this.helpersService.ordersProcessFlow.routes.concat(this.steps);
      }
      this.steps = this.helpersService.initialProcessFlow.routes.concat(this.steps);
    }
    let i = 0; 
    if(this.steps?.length) {
      for (const step of this.steps){
        if(this.currentPath.includes(step.path)){
          this.currentStep = i;
        } else if(this.currentPath.includes("/orders/your-orders") && step.path === "/orders/security-questions") {
          this.currentStep = i;
        }
        i++
      }
    }
  }

  ngOnDestroy() {
    this.sub$.unsubscribe();
    this.streamService.data.refresh();
  }

}

